import { render } from "./BaseTableIncludableData.vue?vue&type=template&id=f437716e&scoped=true"
import script from "./BaseTableIncludableData.vue?vue&type=script&lang=js"
export * from "./BaseTableIncludableData.vue?vue&type=script&lang=js"

import "./BaseTableIncludableData.vue?vue&type=style&index=0&id=f437716e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f437716e"]])

export default __exports__